export const CommunityXpActionKey = {
  POST: 'post',
  COMMENT: 'comment',
  LIKE_RECEIVED: 'like_received',
  REFERRAL_JOIN: 'referral_join',
} as const;

export type CommunityXpActionKeyValue =
  (typeof CommunityXpActionKey)[keyof typeof CommunityXpActionKey];

export const COMMUNITY_XP_LEVEL_MAX = 50;
export const COMMUNITY_XP_RULE_POINTS_MAX = 1000;
export const COMMUNITY_POST_MIN_LEVEL_MAX = 50;

import { DomainError } from '../errors/domain-error';

export function assertCommunityPostMinLevel(params: {
  minLevel?: number | null;
  canSetLevelGate: boolean;
}): void {
  if (params.canSetLevelGate) return;
  if (params.minLevel != null && params.minLevel > 0) {
    throw new DomainError('Only community owners and moderators can set level gates');
  }
}
